// Dependencies
import React, { FunctionComponent } from 'react'

// Styles
import {
  Content,
  Container,
  BannerItem,
  BannerItemLabel,
  BannerItemListItem,
  BannerItemListWrapper,
  BannerItemListItemIcon,
  BannerItemListItemLabel
} from './about-sisu.styles'

// Components
import { Banner } from 'components/Banner'

// Assets
import student from 'assets/student-left.jpg'
import print from 'assets/print-right.jpg'
import arrowRight from 'assets/arrow-circle-right.svg'

export const AboutSisu: FunctionComponent = () => {
  return (
    <Container>
      <Content>
        <Banner
          title="Saiba mais sobre o SiSU 2025"
          imageSource={student}
          imageOrientation="left"
          content={
            <BannerItem>
              <BannerItemLabel>
                O Sistema de Seleção Unificada - SiSU foi criado pelo Ministério
                da Educação para selecionar quem ocupará vagas nas instituições
                públicas, utilizando a nota do ENEM. Entendendo como funciona o
                SiSU, você saberá como usar a sua nota do ENEM neste processo
                seletivo para ingressar em uma universidade pública (através do
                SiSU) ou privada (com o PROUNI ou FIES).
              </BannerItemLabel>
            </BannerItem>
          }
        />

        <Banner
          title="Você tem duas opções de ingresso"
          imageSource={print}
          imageOrientation="right"
          content={
            <BannerItem>
              <BannerItemLabel>
                Quando as inscrições do SiSU abrirem, você deverá entrar no site
                e, após se identificar e confirmar seus dados, fazer duas
                escolhas.
              </BannerItemLabel>

              <div>
                <BannerItemListWrapper>
                  <BannerItemListItem>
                    <BannerItemListItemIcon src={arrowRight} />
                    <BannerItemListItemLabel>
                      Para cada escolha, será necessário informar em qual
                      instituição deseja ingressar e o curso desejado.
                    </BannerItemListItemLabel>
                  </BannerItemListItem>

                  <BannerItemListItem>
                    <BannerItemListItemIcon src={arrowRight} />
                    <BannerItemListItemLabel>
                      Enquanto as inscrições do SiSU estiverem abertas, você
                      poderá modificar suas escolhas quantas vezes julgar
                      conveniente.
                    </BannerItemListItemLabel>
                  </BannerItemListItem>
                </BannerItemListWrapper>
              </div>

              <BannerItemLabel>
                Até que o SiSU seja encerrado, acompanhe as parciais no site,
                para que você possa revisar suas escolhas a fim de obter a
                classificação.
              </BannerItemLabel>
            </BannerItem>
          }
        />
      </Content>
    </Container>
  )
}
